export * from "./product-card-image";
